<template>
    <div>
        <div v-if="showTeacher()" class="teacher-icon" :class="teacherStyle(orderAbility)">
            <i class="fas fa-hat-wizard shadow-text-none"></i>
        </div>
        <div v-else-if="showStudent()" class="student-icon" :class="studentStyle(orderAbility)">
            <i class="fas fa-user-graduate shadow-text-none"></i>
        </div>
        <div v-else>
            <div v-if="showPremium()" :class="starStyle(orderAbility)" id="star-icon">
                <i :class="['fas', isBackendUser() ? 'fa-user' : premiumIcon()]"></i>
            </div>
        </div>
        <div :class="{ 'w-10 h-10 rounded-full overflow-hidden avatar': true, 'no-border': image.length === 0 }">
            <img
                v-if="image.length > 0"
                @error="onImageError"
                :src="image"
                class="w-full h-full object-cover"
                alt="user profile"
            />
            <div v-else class="w-full h-full flex items-center justify-center text-avatar avatar-color">{{ name }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserService from '@/lib/user'

export default {
    name: 'profile-image',

    data() {
        return {
            tokenValid: false,
            image: '',
            name: ''
        }
    },

    mounted() {
        this.setProfileImage()
        this.findOrderAbility()
    },

    computed: {
        ...mapGetters({
            orderAbility: 'orderAbility'
        })
    },

    methods: {
        isLoggedIn() {
            const userService = new UserService()
            return userService.isLoggedIn()
        },

        isBackendUser() {
            const userService = new UserService()
            const role = userService.getUser().role

            return ['super_admin', 'admin', 'contributor', 'premium_user'].indexOf(role) > -1
        },

        setProfileImage() {
            const userService = new UserService()
            let name = userService.getUser()['name'].trim()

            if (
                typeof userService.getUser()['image_profile'] !== 'undefined' &&
                userService.getUser()['image_profile'].length > 0
            ) {
                this.image = userService.getUser()['image_profile']
            } else {
                let nameArr = name.split(' ')
                let firstIndex = 0
                let lastIndex = nameArr.length - 1
                let firstLetter = nameArr[firstIndex].split('')[0]
                let lastLetter = ''
                if (lastIndex > 0) {
                    lastLetter = nameArr[lastIndex].split('')[0]
                }
                this.name = `${firstLetter}${lastLetter}`
            }
        },

        findOrderAbility() {
            if (!this.isLoggedIn()) {
                return
            }

            this.$store.dispatch('findOrderAbility')
        },

        starStyle(starClass) {
            if (this.isBackendUser()) {
                return 'backend-user'
            }

            if (starClass.has_subscribed) {
                return 'subscribed'
            }
            if (starClass.is_24hrs_access) {
                return 'oneday-access'
            }
        },

        teacherStyle(ability) {
            if (ability.role === 'teacher') {
                return 'basic'
            }

            if (ability.role === 'teacher_plus') {
                return 'plus'
            }
        },

        studentStyle(ability) {
            if (ability.role === 'student') {
                return 'basic'
            }

            if (ability.role === 'student_plus') {
                return 'plus'
            }
        },

        showPremium() {
            if (this.isBackendUser()) {
                return true
            }

            if (this.orderAbility.is_24hrs_access || this.orderAbility.is_has_subscribed) {
                return true
            }

            return false
        },

        premiumIcon() {
            if (this.orderAbility.has_subscribed) {
                return 'fa-star'
            }

            return 'fa-clock'
        },

        showTeacher() {
            return this.orderAbility.is_teacher
        },

        showStudent() {
            return this.orderAbility.is_student
        },

        onImageError(event) {
            event.target.onerror = null
            event.target.src = require('@/assets/avatar.jpg')
        }
    }
}
</script>

<style lang="scss" scoped>
.avatar {
    border: 3px solid #fff;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
    &.no-border {
        border: 0;
    }
}
.text-avatar {
    text-decoration: none;
    text-shadow: none;
    font-weight: bold;
    font-size: 1.2rem;
}

#star-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -5px;
    right: -4px;
    font-size: 11px;
    color: white;
    background-color: gold;
    border-radius: 50%;
    padding: 4px;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
    z-index: 999;

    i {
        text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
    }

    //
    &.subscribed {
        background-color: gold;
    }

    &.oneday-access {
        background-color: red;
    }

    &.backend-user {
        background-color: green;
    }

    @media screen and (max-width: 767px) {
        transform: scale(0.9);
    }
}

.teacher-icon,
.student-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -5px;
    right: -4px;
    font-size: 11px;
    color: #fff;
    border-radius: 50%;
    padding: 4px 5px;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
    z-index: 999;

    i {
        text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
    }

    @media screen and (max-width: 767px) {
        transform: scale(0.9);
    }
}

.teacher-icon {
    &.plus {
        background-color: gold;
    }

    &.basic {
        background-color: #4caf50;
    }
}

.student-icon {
    &.plus {
        background-color: gold;
    }

    &.basic {
        background-color: #2196f3;
    }
}
</style>
